import React from 'react'
import getFSKString from '../../../functions/getFSKString'
import getFSKColors from '../functions/getFSKColors'
import { TableWrapper } from './helpersComponents'


const NewsletterContentFSK = ({fsk, buttonWidth, borderRadius, tdStyles, stylesText={} , align="left", theme }) => {
    const hasNoFsk = (fsk === null || fsk === -1)
    const fskKey = hasNoFsk ? 'fsk-unknown' : 'fsk-' + fsk
    const fskThemeColors = getFSKColors(theme ? theme : 'Dark')
    const color = fskThemeColors()[fskKey]

    if(hasNoFsk && stylesText && stylesText.hasOwnProperty('fontSize')) {
        stylesText.fontSize = "22px"
    }

    return (
        <td align={align} style={tdStyles}>
            <TableWrapper className="tinyButton" width={buttonWidth} style={{
                borderSpacing: 0,
                borderCollapse: 'separate',
                border: `1px solid ${color}`,
                ... (borderRadius && {borderRadius: borderRadius})
            }}>
                <tr>
                    <td align="center" valign="top" style={{padding: "0 2px"}}>
                        <span style={{...{color: color}, ...stylesText}}>
                            {getFSKString(fsk)}
                        </span>
                    </td>
                </tr>

            </TableWrapper>
        </td>
    )
}

export default NewsletterContentFSK